import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On route change: scroll to the top, or — when the URL carries a `#hash` — to the
 * matching element. Lazy-loaded pages may not have rendered the target yet, so retry
 * a few animation frames before giving up.
 */
const ScrollToTop = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (!hash) {
            window.scrollTo(0, 0);
            return;
        }

        let raf = 0;
        let attempts = 0;
        const tryScroll = () => {
            const el = document.getElementById(decodeURIComponent(hash.slice(1)));
            if (el) {
                window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: "smooth" });
                return;
            }
            if (attempts++ < 20) {
                raf = requestAnimationFrame(tryScroll);
            }
        };
        raf = requestAnimationFrame(tryScroll);
        return () => cancelAnimationFrame(raf);
    }, [pathname, hash]);

    return null;
};

export default ScrollToTop;
